module.exports = __webpack_public_path__ + "media/post-listing-block-4-overlay-wide@2x.3879f05b.webp";